<script setup lang="ts">

</script>

<template>
  <div class="modal-footer">
    <slot></slot>
  </div>
</template>

<style scoped>
  @reference '@/styles/main.css';

  .modal-footer {
    @apply flex items-center justify-end space-x-4 mt-6;
  }
</style>
